var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileFinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gbqqfnv78a)",
    fill: "#FDB525"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.091 9.144c0 .665-.216 1.28-.582 1.781l1.203 1.191c.18.178.18.467 0 .645a.464.464 0 0 1-.652 0l-1.197-1.185a3.08 3.08 0 0 1-1.844.607c-1.696 0-3.072-1.36-3.072-3.04 0-1.678 1.376-3.04 3.072-3.04 1.697 0 3.072 1.362 3.072 3.04zM17.02 11.27a2.14 2.14 0 0 0 2.15-2.127 2.14 2.14 0 0 0-2.15-2.128 2.14 2.14 0 0 0-2.15 2.128 2.14 2.14 0 0 0 2.15 2.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.39a5.29 5.29 0 0 0 2.917-.875 5.208 5.208 0 0 0 1.933-2.332c.398-.949.502-1.993.3-3.001a5.18 5.18 0 0 0-1.438-2.66A5.267 5.267 0 0 0 8.9.1a5.301 5.301 0 0 0-3.033.295A5.239 5.239 0 0 0 3.51 2.31a5.157 5.157 0 0 0 .653 6.56 5.278 5.278 0 0 0 3.712 1.522zm0-8.658c.692 0 1.369.203 1.944.584.576.38 1.024.921 1.29 1.554a3.43 3.43 0 0 1-.76 3.774 3.534 3.534 0 0 1-3.814.75 3.492 3.492 0 0 1-1.57-1.275A3.438 3.438 0 0 1 5.4 2.746a3.519 3.519 0 0 1 2.475-1.014z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.342a7.927 7.927 0 0 0-5.566 2.285A7.761 7.761 0 0 0 0 18.135c0 .23.092.45.256.612a.88.88 0 0 0 1.238 0 .861.861 0 0 0 .256-.612 6.03 6.03 0 0 1 1.794-4.286 6.158 6.158 0 0 1 4.331-1.776c1.625 0 3.183.64 4.331 1.776A6.03 6.03 0 0 1 14 18.135c0 .23.093.45.257.612a.88.88 0 0 0 1.237 0 .862.862 0 0 0 .257-.612 7.761 7.761 0 0 0-2.31-5.508 7.926 7.926 0 0 0-5.566-2.285z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gbqqfnv78a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v19H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFinder);
export default __webpack_public_path__ + "static/media/profileFinder.280d1f76d07a81bdd2acda46f4f8eefc.svg";
export { ForwardRef as ReactComponent };